import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-upload",
  "use": "icon-upload-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-upload\">\r\n    <path d=\"M768 512l-96 0C654.08 512 640 526.08 640 544 640 561.92 654.08 576 672 576L768 576c35.2 0 64 28.8 64 64l0 192c0 35.2-28.8 64-64 64L192 896c-35.2 0-64-28.8-64-64l0-192c0-35.2 28.8-64 64-64l96 0C305.92 576 320 561.92 320 544 320 526.08 305.92 512 288 512L192 512c-70.4 0-128 57.6-128 128l0 192c0 70.4 57.6 128 128 128l576 0c70.4 0 128-57.6 128-128l0-192C896 569.6 838.4 512 768 512zM186.88 375.04 448 113.28l0 560C448 689.92 462.08 704 478.72 704c17.28 0 30.72-14.08 30.72-30.72L509.44 113.28l261.12 261.76c13.44 14.08 35.84 14.08 49.92 0 13.44-14.08 13.44-35.84 0-49.92l-312.96-313.6C503.04 6.4 497.28 3.84 490.88 2.56 487.68 0.64 483.2 0 478.72 0S470.4 0.64 466.56 2.56C460.8 3.84 454.4 6.4 449.92 11.52l-312.96 313.6c-13.44 14.08-13.44 35.84 0 49.92C151.04 388.48 172.8 388.48 186.88 375.04z\" p-id=\"5895\" fill=\"#95989D\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/upload.svg
// module id = P/TB
// module chunks = 15 16